import {createClient} from 'contentful';
import {documentToReactComponents} from '@contentful/rich-text-react-renderer';
import Image from 'next/image';
import Head from 'next/head';
import React from "react";
import ReactMarkdown from 'react-markdown';

const client = createClient({
    space: process.env.CONTENTFUL_SPACE_ID,
    accessToken: process.env.CONTENTFUL_ACCESS_TOKEN,
});

export async function getStaticPaths() {
    const res = await client.getEntries({
        content_type: 'blogPost',
        include: 2,
    });

    const paths = res.items.map((item) => ({
        params: {slug: item.fields.slug},
    }));

    return {paths, fallback: 'blocking'};
}

export async function getStaticProps({params}) {
    const {items} = await client.getEntries({
        content_type: 'blogPost',
        'fields.slug': params.slug,
        include: 2,
    });

    return {props: {post: items[0]}};
}

export default function BlogPost({post}) {
    return (
        <div className="flex flex-col min-h-screen bg-gray-100 dark:bg-gray-900">
            <Head>
                <title>{`${post.fields.title} | deinSEOExpert`}</title>
                <link rel="icon" href="/favicon.ico" />
                <meta
                    name="description"
                    content="Willkommen auf Dein SEO Expert Blog. Entdecken Sie meine neuesten Artikel, in denen ich mein Expertenwissen im Bereich SEO teile. Hier finden Sie kompetente Beratung und tiefgreifende Analysen zu den neuesten SEO-Trends."
                />
            </Head>

            <main className="flex-grow p-6">
                <div className="max-w-3xl mx-auto">
                    <article>
                        <h1 className="text-4xl font-bold mb-4">{post.fields.title}</h1>
                        <p className="text-gray-500 mb-2">Veröffentlicht
                            am {new Date(post.fields.verffentlichungsdatum).toLocaleDateString('de-DE')}</p>
                        {post.fields.titelbild && (
                            <div className="mb-4">
                                <Image
                                    src={'https:' + post.fields.titelbild.fields.file.url}
                                    width={post.fields.titelbild.fields.file.details.image.width}
                                    height={post.fields.titelbild.fields.file.details.image.height}
                                    alt={post.fields.titelbild.fields.title}
                                />
                            </div>
                        )}
                        <div className="prose markdown-container">
                            <ReactMarkdown>{post.fields.inhalt2}</ReactMarkdown>
                        </div>
                    </article>
                </div>
            </main>
        </div>
    );
}
